var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Question } from "./question";
import { QuestionType } from "./question-type";
var TextboxQuestion = /** @class */ (function (_super) {
    __extends(TextboxQuestion, _super);
    function TextboxQuestion() {
        var _this = _super.call(this) || this;
        _this.type = QuestionType.Textbox;
        _this.skip_scoring = true;
        return _this;
    }
    TextboxQuestion.prototype.setSavedAnswer = function (answer, labels) {
        this._answer = answer;
    };
    Object.defineProperty(TextboxQuestion.prototype, "answer", {
        // public set skip_scoring(v:boolean) {
        //     // make sure it always skip scoring.
        //     this.skip_scoring = true;
        // }
        get: function () {
            return this._answer;
        },
        set: function (v) {
            this._answer = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextboxQuestion.prototype, "answerDisplayText", {
        get: function () {
            return this._answer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextboxQuestion.prototype, "answerForSave", {
        get: function () {
            return this._answer;
        },
        enumerable: true,
        configurable: true
    });
    TextboxQuestion.prototype.hasAnswer = function (answer) {
        return this._answer == answer;
    };
    Object.defineProperty(TextboxQuestion.prototype, "isFilledOut", {
        get: function () {
            return this._answer != null;
        },
        enumerable: true,
        configurable: true
    });
    return TextboxQuestion;
}(Question));
export { TextboxQuestion };



// WEBPACK FOOTER //
// ./src/app/shared/models/textbox-question.ts.pre-build-optimizer.js